import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";

// 動態計算 basename
const basename = (() => {
  const p = window.location.pathname
    .replace(/\/index\.html?$/, "") // 去掉 /index.html
    .replace(/\/$/, "");
  return p || "/";
})();

// 若 URL 以 /index.html 結尾，先把它改掉
if (/\/index\.html?$/.test(window.location.pathname)) {
  const fixed = window.location.pathname.replace(/\/index\.html?$/, "/");
  window.history.replaceState(
    {},
    "",
    fixed + window.location.search + window.location.hash
  );
}

createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>
);

// 禁止 瀏覽器 預設 pinch-zoom(捏合)
// document.addEventListener(
//   "touchmove",
//   function (e) {
//     if (e.touches.length > 1) {
//       e.preventDefault();
//     }
//   },
//   { passive: false }
// );
